import { getReq, postReq, createUrl } from "@/infra/http";
import { Achievement, SpecificType, UpsertAchievement, UpsertSpecificType, AchievementPaginationFilterRequest, UserAchievementPaginationFilterRequest, UserAchievement, userAchievementFromJson } from "@/models/achievement.model";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";


export const getPagedMainAchievements = async (input: AchievementPaginationFilterRequest): Promise<PagedResponseModel<Achievement>> => {
  return await getReq(createUrl("a/Achievement/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getPagedUserAchievements = async (input: UserAchievementPaginationFilterRequest): Promise<PagedResponseModel<UserAchievement>> => {
  return await getReq(createUrl("a/Achievement/UserAchievements/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data, 
    result: res.data.result.map(itm => userAchievementFromJson(itm))
  }));
};

export const getAchievement = async (id: number): Promise<BaseResponseModel<Achievement&SpecificType>> => {
  return await getReq(createUrl(`a/Achievement/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertAchievement = async (input: UpsertAchievement & UpsertSpecificType): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/Achievement/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const autoCheckAchievements = async (userId : number ): Promise<BaseResponseModel<null>> => {
  const reqOptions = {
    headers: {
      "Content-Type": "application/json"
    }
  };    
  return await postReq(createUrl("a/Achievement/AutoCheck"),
    userId,
    reqOptions
  ).then((res: any) => res.data);
};
